import React, { useContext, useState } from 'react';
import { navbarButtons } from '../../const';
import { useSiteMetadataVersions } from '../../queries/useSiteMetadataVersions';
import { buildPathIndexUrl } from '../../utils/buildAppUrl';
import NavbarButton from './components/NavbarButton';
import ToggleNightMode from '../nightToggle/ToggleNightMode';
import { useLocation } from '../../contexts/useLocation';
import { isSearchScreen } from '../../utils/screenRouteChecks';
import { isHomeScreen } from '../../utils/screenRouteChecks';
import documentationLogo from '../../images/domino-logo-large.png';
import { FaSearch } from 'react-icons/fa';
import MobileSearchDrawer from '../shared/MobileSearchDrawer';
import { Link } from 'gatsby';
import SearchBox from '../shared/SearchBox';
import { ResponsiveContext } from '../../contexts/ResponsiveContext';

const Navbar = ({ version }: { version: string }) => {
  const { pathname } = useLocation();
  const { latestVersion } = useSiteMetadataVersions();
  const { responsiveState } = useContext(ResponsiveContext);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <nav
      className={`flex flex-col sticky top-0 left-0 right-0  pt-2 z-30 ${
        isHomeScreen(pathname) ? 'bg-very-dark-grey' : 'bg-bright-white'
      }  dark:bg-very-dark-grey w-full ${isSearchScreen(pathname) ? 'bg-very-dark-grey hidden md:flex' : 'flex'}`}
    >
      <div className={`pb-2 w-full h-full px-2 flex flex-row place-content-between gap-1 items-center `}>
        {(isHomeScreen(pathname) || isSearchScreen(pathname)) && (
          <div className="h-auto w-auto shrink-0 mt-2">
            <Link className="w-28" to="/">
              <img
                loading="lazy"
                src={documentationLogo}
                className="cursor-pointer w-32 h-auto my-0 mx-2"
                alt="domino logo"
                id="domino-logo"
              />
            </Link>
          </div>
        )}
        <div className="hidden md:flex flex-row shrink w-fit mt-3 gap-0 md:gap-2 align-middle place-content-evenly items-center">
          {navbarButtons.map(({ path, label }) => (
            <NavbarButton
              key={path}
              path={path}
              label={label}
              route={buildPathIndexUrl({
                latestVersion,
                version,
                path,
              })}
            />
          ))}
        </div>
        {/* Search box and light/dark toggle. */}
        <div className="flex items-center mt-2 w-auto justify-center lg:justify-end h-full">
          <div className="flex flex-row justify-center items-center w-auto">
            <div className="hidden md:flex">
              {/* Search box on search results page */}
              {isSearchScreen(pathname) && !responsiveState.isMenuActive && !responsiveState.isSidebarActive && (
                <SearchBox hideResults={true} isSearchScreen={true} />
              )}
              {/* Search box on all other pages */}
              {!isSearchScreen(pathname) && <SearchBox />}
            </div>

            {isHomeScreen(pathname) || isSearchScreen(pathname) ? (
              <div className="flex flex-row">
                <div>
                  <ToggleNightMode
                    moonStroke="stroke-bright-white"
                    sunStroke="stroke-bright-white"
                    lightBackground="bg-medium-dark-grey"
                    darkBackground="bg-medium-dark-grey"
                    lightDotColour="after:bg-very-light-grey"
                    darkDotColour="after:bg-very-light-grey"
                  />
                </div>
                <div className="w-8 flex justify-end">
                  <button
                    onClick={() => setSearchOpen((prev) => !prev)}
                    className={`w-8 h-8 md:hidden border border-medium-dark-grey cursor-pointer z-50 rounded flex items-center justify-center ${
                      searchOpen ? 'text-vivid-orange' : 'text-white'
                    }`}
                  >
                    <FaSearch />
                  </button>
                </div>
              </div>
            ) : (
              <div className="hidden md:flex">
                <ToggleNightMode />
              </div>
            )}
          </div>
        </div>
      </div>
      {isHomeScreen(pathname) && (
        <div className="w-full md:hidden pb-1">
          <MobileSearchDrawer searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
        </div>
      )}
    </nav>
  );
};

export default Navbar;
